import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Betaalmethoden',
  fields: {
    hidden_payment_methods: {
      label: 'Verborgen betaalmethoden',
    },
    has_online_payments: {
      label: 'Online betalingen beschikbaar',
    },
    has_paypal_upcharge: {
      label: '3,5% toeslag voor PayPal-transacties',
    },
    has_cash_payments: {
      label: 'Contante betalingen beschikbaar',
    },
    has_occ_cash_payments: {
      label: 'Callcenter contante betalingen ingeschakeld',
    },
    has_in_store_card_payments: {
      label: 'Betaling met kaart in de winkel beschikbaar',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Contante betalingen aanduiden als "Factuur"',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Kaart',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple Pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'SEPA-incasso',
    [PaymentMethods.CASH]: 'Contant',
    [PaymentMethods.BACS_DEBIT]: 'Bacs-incasso',
    [PaymentMethods.PAY_BY_BANK]: 'Betalen via bank',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Afhalen',
    [ORDER_METHODS.delivery]: 'Bezorging',
    [ORDER_METHODS.on_site]: 'Tafelbestellen',
  },
  modals: {
    confirmation: {
      title: 'Weet u het zeker?',
      description:
        'Na bevestiging worden online betalingen <strong>{{onlineState}}</strong> en contante betalingen <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'uit',
    on: 'aan',
  },
  buttons: {
    save: 'Opslaan',
    configure_online_payments: 'Online betalingen configureren',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
